import styled from "styled-components";

export const SidebarContainer = styled.aside`
  width: 280px;
  height: 100vh;
  background: #f8fafc;
  border-right: 1px solid #e2e8f0;
  display: flex;
  flex-direction: column;
  padding: 0;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1000;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  @media (max-width: 1024px) {
    transform: ${({ isOpen }) => (isOpen ? "translateX(0)" : "translateX(-100%)")};
    box-shadow: 20px 0 50px rgba(0, 0, 0, 0.1);
  }
`;

export const Logo = styled.div`
  padding: 32px 24px;
  display: flex;
  align-items: center;
  gap: 12px;

  .logo-wrapper {
    width: 45px;
    height: 45px;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
    border: 2px solid #fff;
    
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .logo-text {
    font-size: 1.25rem;
    font-weight: 900;
    color: #1e293b;
    letter-spacing: -0.5px;
    
    span {
      color: #e74c3c;
    }
  }
`;

export const NavList = styled.nav`
  flex: 1;
  padding: 0 16px;
  overflow-y: auto;

  .nav-group {
    margin-bottom: 24px;
  }
`;

export const SectionTitle = styled.h4`
  font-size: 0.7rem;
  text-transform: uppercase;
  color: #94a3b8;
  font-weight: 800;
  letter-spacing: 1px;
  padding: 0 12px;
  margin-bottom: 8px;
`;

export const NavItem = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  border-radius: 12px;
  color: #64748b;
  text-decoration: none;
  font-weight: 600;
  margin-bottom: 4px;
  transition: all 0.2s ease;

  .icon-area {
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
  }

  &:hover {
    background: #f1f5f9;
    color: #1e293b;
    transform: translateX(4px);
  }

  &.active {
    background: #fff;
    color: #e74c3c;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
    
    .icon-area {
      color: #e74c3c;
    }
  }
`;

export const LogoutArea = styled.div`
  padding: 24px 16px;
  border-top: 1px solid #e2e8f0;
`;

export const LogoutButton = styled.button`
  all: unset;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  border-radius: 12px;
  color: #64748b;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: #fee2e2;
    color: #ef4444;
  }
`;

export const MobileMenuBtn = styled.button`
  display: none;
  position: fixed;
  top: 15px;
  right: 15px;
  z-index: 1100;
  background: #e74c3c;
  color: #fff;
  border: none;
  width: 45px;
  height: 45px;
  border-radius: 10px;
  cursor: pointer;
  box-shadow: 0 4px 15px rgba(231, 76, 60, 0.4);

  @media (max-width: 1024px) {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.4);
  backdrop-filter: blur(4px);
  z-index: 999;
  opacity: ${({ isOpen }) => (isOpen ? "1" : "0")};
  visibility: ${({ isOpen }) => (isOpen ? "visible" : "hidden")};
  transition: all 0.3s ease;
`;